const shadows = {
  card: '2px 4px 10px rgba(0, 0, 0, 0.2)'
};

export default shadows;
